"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerEventEmitter = void 0;
var PlayerEventEmitter = /** @class */ (function () {
    function PlayerEventEmitter() {
        this.events = {};
        this.callbacks = new Map();
    }
    PlayerEventEmitter.prototype.dispatch = function (event, data) {
        if (!this.events[event])
            return;
        this.events[event].forEach(function (callback) { return callback(data); });
    };
    PlayerEventEmitter.prototype.subscribe = function (event, callback) {
        if (!this.events[event])
            this.events[event] = [];
        this.events[event].push(callback);
        this.callbacks.set(callback, event);
    };
    PlayerEventEmitter.prototype.unsubscribe = function (callback) {
        var type = this.callbacks.get(callback);
        if (!type)
            return;
        this.events[type] = this.events[type].filter(function (cb) { return cb !== callback; });
        this.callbacks.delete(callback);
    };
    return PlayerEventEmitter;
}());
exports.PlayerEventEmitter = PlayerEventEmitter;
